import React from 'react';

const ContactItem = ({ icon: Icon, label, value, darkMode }) => {
  return (
    <div className="flex items-center gap-4">
      <div className={`${darkMode ? 'bg-white' : 'bg-slate-900'} w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0`}>
        <Icon className={`w-6 h-6 ${darkMode ? 'text-slate-900' : 'text-white'}`} />
      </div>
      <div>
        <div className={`${darkMode ? 'text-slate-400' : 'text-slate-500'} text-sm`}>{label}</div>
        <div className={`${darkMode ? 'text-white' : 'text-slate-900'} font-semibold`}>{value}</div>
      </div>
    </div>
  );
};

export default ContactItem;